import React, { type ReactNode } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import ErrorBoundary from '@jira/platform__error-boundary/src/ErrorBoundary.tsx';

type FlagsBoundaryProps = {
	children: ReactNode;
	packageName: string;
	teamName?: string;
};

export const FlagsBoundary = ({
	children,
	packageName,
	teamName,
}: FlagsBoundaryProps): React.JSX.Element => (
	<ErrorBoundary id="flags" packageName={packageName} teamName={teamName}>
		<Placeholder name="flags-boundary" fallback={<></>}>
			{children}
		</Placeholder>
	</ErrorBoundary>
);
